import React, { PureComponent, useState } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';
import { useInterval } from '$app/utils/util';

import Header from './Header';
import Body from './Body';

const Reminder = styled.div`
  background: #f6faff;
  font-size: 13px;
  padding: 8px 8px;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid rgba(187, 187, 187, 0.62);
  text-decoration: none;
  color: #111;
  ${({ overdue }) =>
    overdue &&
    css`
      background: #fff0f0;
      border: 1px solid #ff5858;
    `}

  &:hover {
    text-decoration: none !important;
  }
`;

const ReminderDue = styled.span`
  color: #00b67a;
  font-size: 18px;
  margin: 0 2px;
  ${({ overdue }) =>
    overdue &&
    css`
      color: #ff5858;
    `}
`;

const BasicLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;

const RemindersList = ({ reminders = [] }) =>
  (reminders || []).map((reminder) => {
    const [count, setCount] = useState(0);
    useInterval(() => setCount(count + 1), 10000);
    const now = moment().format();
    const remainingTime = moment(reminder.dueDateTime).fromNow(true);
    const isDueNow = moment(reminder.dueDateTime).isBefore(now);
    if (isDueNow) {
      return (
        <Reminder key={`${reminder.reminderId}_${count}`} overdue>
          Quoted - Call Due <ReminderDue overdue>{remainingTime} ago</ReminderDue>
        </Reminder>
      );
    }
    return (
      <Reminder key={`${reminder.reminderId}_${count}`}>
        Quoted - Call Due in <ReminderDue>{remainingTime}</ReminderDue>
      </Reminder>
    );
  });

class DashboardCard extends PureComponent {
  state = {
    collapsed: true,
  };

  toggleCollapse = () => {
    if (this.state.collapsed) this.setState({ collapsed: false });
    else this.setState({ collapsed: true });
  };

  render() {
    const { booking, caseManagers, currentUser, drivers, laneId, template } = this.props;
    return (
      <div className="custom-card">
        <div
          className={classNames('card animated zoomIn', {
            collapsed: this.state.collapsed,
          })}
        >
          <div className="card-content">
            <Header
              caseManagers={caseManagers}
              currentUser={currentUser}
              booking={booking}
              toggleCollapse={this.toggleCollapse}
              laneId={laneId}
              template={template}
            />
            <Body drivers={drivers} booking={booking} />
            <BasicLink to={`/bookings/${booking.bookingId}`}>
              <RemindersList reminders={booking.reminders} />
            </BasicLink>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardCard;
